import LoadingButton from '@mui/lab/LoadingButton';
import React from 'react';

export const SWLoadingButtonOutlined = (props?: any): JSX.Element => (
  <LoadingButton variant="outlined" {...props} color="primary">
    {props.children}
  </LoadingButton>
);
